module.exports = __webpack_public_path__ + "img/29.e441c94b.png";